
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderLink from './headerLink.vue'

@Component({
  components: {
    HeaderLink
  }
})
export default class HeaderLinkPop extends Vue {
  @Prop({ type: Boolean, default: false }) isTop

  getPopupContainer(triggerNode: HTMLElement) {
    const el: HTMLElement = document.querySelector('#header-link-id') ?? document.body

    return el
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
